import LoopedAudio from 'app/components/media/LoopedAudio';
import { assetBaseURL } from 'app/config/client';
import { useCallBreakpoint } from 'app/containers/call/CallBreakpoint';
import { LessonSoundStage } from 'app/models/ui/call/lesson/constants';
import React, { FC } from 'react';

const LESSON_CALL_SOUND_SOURCE = `${assetBaseURL}/sounds/rtc/level_up.mp3`;

const LessonStartSound: FC = () => {
  const { lessonUIState } = useCallBreakpoint();

  if (lessonUIState.sound === LessonSoundStage.Start) {
    return <LoopedAudio src={LESSON_CALL_SOUND_SOURCE} />;
  }

  return null;
};

export default LessonStartSound;
